<template>
    <b-button 
        v-if="permiteBuscar"
        class="float-right"
        variant="success"
        @click.stop="BuscarDespesa()"
    >
        <span>
            <i class="fa fa-plus mr-2"></i> Buscar despesa de compra
        </span>
    </b-button>
</template>

<script>
export default {
    methods: {
        BuscarDespesa() {
            this.$router.push({
                name: `${this.$route.name}_BuscarCompra`,
            })
        }
    },

    computed: {
        permiteBuscar() {
            return (this.$temAcessoView('DESP-GERAIS-REQ-07') && this.$route.name == 'DespesasGerais_Requisitantes_Despesas') 
        }
    }
}
</script>